import { render, staticRenderFns } from "./AddCampaign.vue?vue&type=template&id=764aae86&scoped=true&"
import script from "./AddCampaign.vue?vue&type=script&lang=js&"
export * from "./AddCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaign.vue?vue&type=style&index=0&id=764aae86&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764aae86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
